import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Logo from "../components/Logo";
import { LOGO_AUTH_VERIFY_EMAIL } from "../config/logoSizes";
const VerifyEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || sessionStorage.getItem("pendingEmail") || "";
  const [code, setCode] = useState("");
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  useEffect(() => {
    if (!email) navigate("/signup");
  }, [email, navigate]);
  useEffect(() => {
    const note = location.state?.signupNote;
    if (!note || !email) return;
    setAlert({ type: "success", msg: note });
    navigate(location.pathname, { replace: true, state: { email } });
  }, [email, location.state?.signupNote, location.pathname, navigate]);
  useEffect(() => {
    if (cooldown > 0) {
      const t2 = setTimeout(() => setCooldown((c) => c - 1), 1e3);
      return () => clearTimeout(t2);
    }
  }, [cooldown]);
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (code.length !== 6) {
      setAlert({ type: "error", msg: "Please enter the 6-digit code." });
      return;
    }
    setLoading(true);
    try {
      await axios.post("/api/auth/verify-email", { email, code });
      sessionStorage.removeItem("pendingEmail");
      sessionStorage.setItem("taweel_show_welcome", "1");
      navigate("/signin", { state: { successMsg: t("accountCreated") } });
    } catch (err) {
      setAlert({ type: "error", msg: err.response?.data?.message || t("error") });
    } finally {
      setLoading(false);
    }
  };
  const handleResend = async () => {
    if (cooldown > 0) return;
    setResending(true);
    try {
      await axios.post("/api/auth/resend-code", { email });
      setAlert({ type: "success", msg: "New code sent to your email." });
      setCooldown(60);
    } catch (err) {
      setAlert({ type: "error", msg: err.response?.data?.message || "Failed." });
    } finally {
      setResending(false);
    }
  };
  return <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-card">
        <div className="auth-logo-area" onClick={() => navigate("/chat")} style={{ cursor: "pointer" }}>
          <Logo variant="full" size={LOGO_AUTH_VERIFY_EMAIL} className="auth-logo-img" />
        </div>
        <p className="auth-title">{t("verifyEmail")}</p>
        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <p style={{ fontSize: 13, color: "var(--text-2)", lineHeight: 1.7 }}>
            {t("codeSentTo")}<br />
            <strong style={{ color: "var(--accent)" }}>{email}</strong>
          </p>
        </div>
        <div style={{ background: "var(--bg-base)", border: "1px solid var(--border2)", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 12.5, color: "var(--text-2)", textAlign: "center", lineHeight: 1.6 }}>
          📧 {t("checkSpam")}
        </div>
        {alert && <div className={`form-alert ${alert.type}`}>{alert.msg}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Verification Code</label>
            <input
    className="form-input code-input"
    type="text"
    maxLength={6}
    placeholder="000000"
    value={code}
    onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
    autoFocus
  />
          </div>
          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? <><div className="spinner" /> Verifying...</> : "Verify Email \u2713"}
          </button>
        </form>
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <button
    onClick={handleResend}
    disabled={resending || cooldown > 0}
    style={{ background: "none", border: "none", color: cooldown > 0 ? "var(--text-3)" : "var(--accent)", cursor: cooldown > 0 ? "default" : "pointer", fontSize: 13, fontFamily: "inherit", fontWeight: 500 }}
  >
            {cooldown > 0 ? `Resend in ${cooldown}s` : resending ? "Sending..." : t("resendCode")}
          </button>
        </div>
      </div>
    </div>;
};
var stdin_default = VerifyEmail;
export {
  stdin_default as default
};
